import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import DataTable from '../../common/components/DataTable';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getCustomerCodeDataList } from '../customerMappingDashboard/MappingActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { useBackNavigation } from '../../../hooks/BackNavigation';
import { AESDecrypt } from '../../../encrypt-util';
import { getCustomerCodeDetails } from './CustomerCodeAction';
import useDataCountry from '../../../hooks/useDataCountry';

const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

const CustomerCodeDetails = () => {
    const { t } = useTranslation();
    const data = useSelector((state: RootState) => state.customerCodeRequest.customerCodeDataList)
    const dispatch = useDispatch<AppDispatch>()
    const linerId = useSelector(
        (state: RootState) => state.userProfile.profile.partnerId
    );
    const dataCountry = useDataCountry();

    const { custId } = useParams()
    const custIdDecrypted = AESDecrypt(custId) ?? '';

    const onBack = useBackNavigation();

    useEffect(() => {
        if (custIdDecrypted)
            dispatch(getCustomerCodeDetails({ custIdDecrypted, linerId, dataCountry }))
    }, [custIdDecrypted, linerId, dataCountry])

    const columnConfig = [
        {
            accessor: 'id',
            Header: '',
            width: 0,
            maxWidth: 0,
        },
        {
            accessor: 'linerName',
            Header: t('resource_1:liner'),
            width: 180,
            maxWidth: 180
            // Cell: (rowData: any) => {
            //     const { liner } = rowData.row.original
            //     return <span className='fs--1'>{linerOptions.find((i: any) => i.value == liner)?.text ?? liner}</span>
            // }
        },
        {
            accessor: 'customerCode',
            Header: t('resource_1:customercode'),
            width: 180,
            maxWidth: 180
        },
        {
            accessor: 'matchCode',
            Header: 'Match Code',
            width: 180,
            maxWidth: 180,
        },
    ];

    return (
        <Card className='h-100 overflow-auto'>
            <Card.Header className='d-flex align-items-center border-bottom sticky-top bg-white'>
                <FontAwesomeIcon
                    icon={faArrowAltCircleLeft}
                    className='text-warning cursor-pointer fa-lg mb-1 me-1'
                    onClick={onBack}
                />
                <h2 className='fs-0 text-primary mb-1'>{'Customer Code Details'}</h2>
            </Card.Header>
            <Card.Body>
                <div className='col-lg-12 mt-2 mb-2 d-flex flex-column'>
                    <DataTable
                        gridName='CUSTOMERCODEDETAILS'
                        columns={columnConfig}
                        data={data}
                        shortPrepend='customercode_'
                        perPage={100}
                        sortable={true}
                        searchable={false}
                        showColumnFilter={false}
                        selection={false}
                        pagination={false}
                        seekPagination={false}
                        showExport={false}
                        localFilter={true}
                        uniqueFilterKey='customerCodeDetails'
                        autoHeight={true}
                        maxHeight='62vh'
                        tableMinHeight={400}
                        staticHiddenCols={['id']}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default CustomerCodeDetails;
